import type { RuntimeAtlas } from './atlasContract.js';
import type { AtlasLevel } from './levels.js';
import type { AtlasManifest } from './manifest.js';

export function validateAtlasInventory(manifest: AtlasManifest, level: AtlasLevel, atlas: RuntimeAtlas): void {
  const entry = manifest.levels[level];
  const expected = [entry.atlas, ...atlas.pages.map((page) => page.image)].sort();
  if (atlas.level !== level || atlas.sourceRevision !== manifest.sourceRevision) throw new Error('atlas manifest revision mismatch');
  if (Object.keys(entry.files).sort().join('\0') !== expected.join('\0')) throw new Error('atlas manifest unrelated inventory');
  for (const page of atlas.pages) if (entry.files[page.image] !== page.imageSha256) throw new Error('atlas page inventory mismatch');
}
